'use client';
import React from 'react';
import  './TwoPanels.scss';
import BookingToolPanel from './BookingToolPanel';
import FinanceSearchPanel from './FinanceSearchPanel';
import PartExchangePanel from './PartExchangePanel';
import TextPanel from './TextPanel';

interface TwoPanelsProps {
  props: Record<string, any>;
}

const panelMap: Record<string, (props: Record<string, any>) => React.ReactNode> = {
  booking_tool_panel: (props) => <BookingToolPanel {...props} />,
  finance_search_panel: (props) => <FinanceSearchPanel {...props} />,
  part_exchange_panel: (props) => <PartExchangePanel {...props} />,
  text_panel: (props) => <TextPanel {...props} />,
};

export default function TwoPanels({ props }: TwoPanelsProps) {

    const { left_panel, right_panel } = props;

    const LeftComponent = panelMap[left_panel];
    const RightComponent = panelMap[right_panel];

    return (
      <>
  

          <div className="l-node-frontpage__wrap ">
            <div className="l-node-frontpage__block-small-row">
         
              {LeftComponent ? LeftComponent(props) : null}
              {RightComponent ? RightComponent(props) : null}

            </div>
          </div>

      </>
    );
  }
  